window.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.query-items-clickable > li');
    for (const element of elements) {
        element.addEventListener('click', () => {
            const link = element.querySelector('.wp-block-post-title > a');
            if (link) {
                window.location.href = link.href;
            }
        });
    }

    const jobOffersElements = document.querySelectorAll('.job-offer');
    for (const element of jobOffersElements) {
        element.addEventListener('click', () => {
            const link = element.querySelector('.wp-block-button > a');
            if (link) {
                link.click();
            }
        });
    }

    const sliderButtons = document.querySelectorAll('.slider-button');
    for (const element of sliderButtons) {
        element.addEventListener('click', () => {
            const link = element.querySelector('a');
            if (link) {
                link.click();
            }
        });
    }


    const posts = document.querySelectorAll('.type-post');
    for (const post of posts) {
        post.addEventListener('click', function() {
            const link = post.querySelector('a');
            if (link) {
                window.location.href = link.href;
            }
        });
    }


});
